import { FC } from "react";
import {
  CARD_INTRODUCTION_DEFAULTS,
  TCardIntroductionProps,
} from "./Card.config";
import { TextBody } from "../../typography/TextBody";
import { TextEyebrow } from "../../typography/TextEyebrow";
import { cn } from "@/ui/lib";

export const CardIntroduction: FC<TCardIntroductionProps> = ({
  eyebrow,
  title,
  description,
  className,
  titleWrap = CARD_INTRODUCTION_DEFAULTS.titleWrap,
}) => (
  <div
    data-component="CardIntroduction"
    className={
      cn(
        "flex flex-col space-y-2 p-4",
        className,
      )
    }
  >
    <TextEyebrow
      child={{
        component: "subtitle",
        size: 3,
        children: title,
        isResponsive: false,
        className: titleWrap,
        title,
      }}
    >{ eyebrow }</TextEyebrow>
    { description ? (
      <TextBody size={2} isResponsive={false}>{ description }</TextBody>
    ): null }
  </div>
);
